export const CriticalityLevelEnum = {
  REGULAR: 'Regular',
  IMPORTANT: 'Important',
  CRITICAL: 'Critical'
}

export const CriticalityEnum = {
  REGULAR: 'regular',
  IMPORTANT: 'important',
  CRITICAL: 'critical',
  properties: {
    regular: {
      title: 'Regular',
      state: 'REGULAR',
      size: 12
    },
    important: {
      title: 'Important',
      state: 'IMPORTANT',
      size: 24
    },
    critical: {
      title: 'Critical',
      state: 'CRITICAL',
      size: 36
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/criticality.constants.js